import { render } from "./StockPartInfo.vue?vue&type=template&id=12805ec2&scoped=true"
import script from "./StockPartInfo.vue?vue&type=script&lang=js"
export * from "./StockPartInfo.vue?vue&type=script&lang=js"

import "./StockPartInfo.vue?vue&type=style&index=0&id=12805ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12805ec2"]])

export default __exports__